import { useDispatch, useSelector } from "react-redux";
import { openModal, setSplitScreen } from "../../../slices/common/reducer";
import { Link, useNavigate } from "react-router-dom";
import "./style.scss";
import { Button, Row, CardHeader } from "reactstrap";
import {
  AdvancedFilterIcon,
  DashIcon,
  DownCarrot,
  DownCarrotIcon,
  UpCarrot,
  UpCarrotIcon,
} from "../../../assets/images/svg/svg";
import { Dropdown, DropdownMenu, DropdownToggle, Form } from "reactstrap";
import { useState } from "react";
import Select from "react-select";
import SelectDropdown from "../../../pages/Settings/UserManagement/Users/SelectedUser/SelectDropdownPspMapping";

const CommonHeader = ({
  title,
  newButton,
  checkAccessCreate,
  buttonTitle,
  formLink,
  save,
  apiUpdate,
  filterComponent,
  dash,
  update,
  selectComponent,
  addClickHandler,
  showAddBtn,
  filterIcon,
  offcanvasopen,
}) => {
  const dispatch = useDispatch();
  const nav = useNavigate();
  const [dropdown, setDropdown] = useState(false);

  const downloadLoading = useSelector((state) => state.common.loader.download);

  const handleNewButtonClick = () => {
    if (formLink) {
      nav(formLink);
    } else {
      dispatch(openModal(true));
    }
  };

  const toggleDropdown = () => {
    setDropdown(!dropdown);
  };

  return (
    <CardHeader className="card-header border-0">
      <Row className="align-items-center gy-3">
        <div className="col-sm">
          {filterComponent && (
            <div className="filter-component">{filterComponent}</div>
          )}
        </div>
        <div className="col-sm-auto">
          <div className="d-flex gap-4 flex-wrap">
            <div className="d-flex gap-4 flex-wrap">
              {filterIcon && (
                <Button className="primary-outline" onClick={offcanvasopen}>
                  <AdvancedFilterIcon />
                </Button>
              )}
            </div>
            {dash && <div className="vertical-line"></div>}
            {(checkAccessCreate === undefined || checkAccessCreate === true) &&
              newButton && (
                <>
                  <Button
                    color="primary primary_button"
                    onClick={handleNewButtonClick}
                  >
                    <i className="ri-add-fill me-1 align-bottom"></i>
                    {buttonTitle}
                  </Button>
                </>
              )}
            {save && (
              <Button color="primary primary_button" onClick={apiUpdate}>
                <i className="ri-add-fill me-1 align-bottom"></i>
                Save
              </Button>
            )}
            {update && (
              <Button color="primary primary_button" onClick={apiUpdate}>
                Update
              </Button>
            )}
            {selectComponent && <div>{selectComponent}</div>}
          </div>
          {showAddBtn && (
            <button
              className="add-payment-btn"
              onClick={() => addClickHandler()}
            >
              {" "}
              <i className="ri-add-fill me-1 align-bottom"></i> {title}
            </button>
          )}
        </div>
      </Row>
    </CardHeader>
  );
};

export default CommonHeader;
